import { CMS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
export const MAX_VISIBLE_PURCHASE_MOTIONS_PA = productLine => productLine && [CMS, SALES, SERVICE].includes(productLine) ? 3 : 2;